import { Box, Group, Stack, createStyles } from '@mantine/core';
import { Icon, Text, Title } from '@repo/foundations';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { capitalize } from 'lodash-es';
import type { IUser } from '../../../api';
import { UserAvatar } from '../../../components/UserAvatar';

dayjs.extend(isToday);

const useStyles = createStyles(() => ({
	headerWrapper: {
		display: 'flex',
		alignItems: 'center',
		gap: '20px',
		marginBottom: 40,
	},
}));

interface IProfileHeaderProps {
	user: IUser;
}

function ProfileHeader({ user }: IProfileHeaderProps) {
	const { classes } = useStyles();

	return (
		<Box className={classes.headerWrapper}>
			<UserAvatar size="md" user={user} />
			<Stack spacing="xs">
				<Title order={2}>{user.display_name}</Title>
				<Group>
					{dayjs(user.last_login).isToday() ? (
						<Group spacing="xs">
							<Icon name="circleCheck" color="icon/success/default" />
							<Text>Active</Text>
						</Group>
					) : (
						user.last_login && (
							<Group spacing="xs">
								<Icon name="calendarTime" color="icon/success/default" />
								<Text>
									Last active {dayjs(user.last_login).format('DD MMM YYYY')}
								</Text>
							</Group>
						)
					)}
					<Group spacing="xs">
						<Icon name="userCheck" />
						<Text>{capitalize(user.role)}</Text>
					</Group>
					<Group spacing="xs">
						<Icon name="calendar" />
						<Text>Joined {dayjs(user.created_at).format('MMM YYYY')}</Text>
					</Group>
				</Group>
			</Stack>
		</Box>
	);
}

export default ProfileHeader;
